export default "__VITE_ASSET__Cn01U4xK__"